import { render, staticRenderFns } from "./QuoteStepItem.vue?vue&type=template&id=022543f5"
import script from "./QuoteStepItem.vue?vue&type=script&lang=ts"
export * from "./QuoteStepItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports